export const shouldShowMarketingModal = () => {
  const params = new URLSearchParams(window.location.search);
  const utmCampaign = params.get('utm_campaign');
  
  return utmCampaign === 'exp';
};

export const hasUserSeenMarketingModal = () => {
  return localStorage.getItem('crds-marketing-campaign-modal-completed') !== null;
};

export const markMarketingModalCompleted = () => {
  localStorage.setItem('crds-marketing-campaign-modal-completed', 'true');
};